<template>
    <div class="bg-primary">
        <spinner></spinner>
        <v-login v-if="isVerification"></v-login>
        <v-suspended v-if="isVerification"></v-suspended>
        <q-layout :view="layout" :class="textAlign">

            <!-- Navbar -->
            <q-layout-header v-if="isVerification" :reveal="true" style="position: relative;">
                <v-header @rightDrawerToogle="right = !right"></v-header>
            </q-layout-header>

            <!-- Right Side Panel -->
            <q-layout-drawer v-if="isVerification" :side="position" v-model="right" behavior="mobile" style="background: none">
                <v-menu></v-menu>
            </q-layout-drawer>

            <!-- Content -->
            <q-page-container style="padding-top:0; padding-bottom: 50px;">
                <router-view/>
            </q-page-container>

            <!-- Footer -->
            <q-layout-footer v-if="isVerification" id="footer" class="fixed-bottom" style="position: fixed !important">
                <v-footer></v-footer>
            </q-layout-footer>

        </q-layout>
    </div>
</template>

<script>
    import VHeader from '../components/Header'
    import VMenu from '../components/Menu'
    import VFooter from '../components/Footer'
    import VLogin from '../pages/auth/login'
    import moment from "moment"

    import {
        QLayout,
        QLayoutHeader,
        QLayoutDrawer,
        QLayoutFooter,
        QPageContainer,
        Cookies
    } from 'quasar-framework'
    import VSuspended from "../pages/auth/suspended";

    export default {
        name: 'MainLayout',

        components: {
            VSuspended,
            VHeader,
            VMenu,
            VFooter,
            VLogin,
            QLayout,
            QLayoutHeader,
            QLayoutDrawer,
            QLayoutFooter,
            QPageContainer
        },

        data() {
            return {
                right: false,
                lang: window.config.locale.toUpperCase(),
                textAlign: '',
                position: 'right',
            }
        },
        beforeCreate() {
            if (window.location.pathname !== '/trck' && !window.location.pathname.includes('/access') && window.location.pathname !== '/ageVerification' && document.cookie.indexOf('cookie_notice_accepted') < 0) {
                let date = moment().format("HH")
                let day = moment().format('dddd')
                if (date > '08' && date < '19' && day !== 'Sábado' && day !== 'Domingo') {
                    this.$router.push('/ageVerification')
                } else {
                    Cookies.set('cookie_notice_accepted', true, {expires: 1,path: '/'})
                }
            }
        },
        mounted() {
            this.setLang()
            document.getElementById("spinner").style.display = "none";
        },

        computed: {
            layout() {
                if (this.$breakpoints.isGreaterThan('sm'))
                    return 'lhr lpr lfr'
                return 'lHr lpr lFr'
            },
            isVerification () {
                return document.cookie.indexOf('cookie_notice_accepted') !== -1
            }
        },
        methods: {
            setLang(){
                if (this.lang === 'AR'){
                    this.textAlign = 'text-right'
                    this.position = 'right left'
                }else{
                    this.position = 'right'
                    this.textAlign = 'text-left'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue